import { IRole, ICreateRole, IUpdateRole } from '../types/roles.types';
import { store } from '../store';
import { handleSessionExpired } from './sessionHandler';

const API_URL = process.env.REACT_APP_API_URL;

export class RolesService {
    // Removed authToken logic

    private static async request<T>(
        endpoint: string,
        method: 'GET' | 'POST' | 'PUT' | 'DELETE' = 'GET',
        body?: any
    ): Promise<T> {
        try {
            const response = await fetch(`${API_URL}/roles${endpoint}`, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: body ? JSON.stringify(body) : undefined,
                credentials: 'include', // Send cookies for session auth
            });
            if (!response.ok && response.status === 401) {
                handleSessionExpired();
            }
            return response.json();
        } catch (error) {
            console.error('API request failed:', error);
            throw new Error('An error occurred');
        }
    }

    static async getRoles(teamId?: string): Promise<IRole[]> {
        return await this.request<IRole[]>(teamId ? `?teamId=${teamId}` : '');
    }

    static async createRole(role: ICreateRole): Promise<IRole> {
        return await this.request<IRole>('', 'POST', role);
    }

    static async updateRole(role: IUpdateRole): Promise<IRole> {
        return await this.request<IRole>(`/${role.id}`, 'PUT', role);
    }

    static async deleteRole(id: number): Promise<{ success: boolean; message: string }> {
        const response = await this.request<{ success: boolean; message: string }>(`/${id}`, 'DELETE');
        return response;
    }
}

export default RolesService; 